import { createFileRoute, notFound } from "@tanstack/react-router";
import NotFound from "@/pages/NotFound";
import BlogPost from "@/pages/BlogPost";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta, readable } from "@/lib/routeSocial";
import { findBlogPost } from "@/lib/blog";

export const Route = createFileRoute("/blog/$slug")({
  beforeLoad: ({ params }) => {
    if (!findBlogPost(params.slug)) throw notFound();
  },
  notFoundComponent: NotFound,
  head: ({ params }) => {
    const post = findBlogPost(params.slug);
    const url = `https://statlign.com/blog/${params.slug}`;
    const scripts = post
      ? [
          {
            type: "application/ld+json",
            children: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BlogPosting",
              headline: post.title,
              description: post.description,
              datePublished: post.date,
              dateModified: post.date,
              author: { "@type": "Organization", name: post.author },
              publisher: { "@type": "Organization", name: "Statlign", url: "https://statlign.com" },
              mainEntityOfPage: url,
              url,
            }),
          },
          {
            type: "application/ld+json",
            children: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                { "@type": "ListItem", position: 1, name: "Home", item: "https://statlign.com/" },
                { "@type": "ListItem", position: 2, name: "Blog", item: "https://statlign.com/blog" },
                { "@type": "ListItem", position: 3, name: post.title, item: url },
              ],
            }),
          },
        ]
      : [];
    return {
      meta: socialMeta({
        seo: { topics: ["blog"] },
        title: post ? `${post.title} | Statlign` : `${readable(params.slug)} | Statlign Blog`,
        description:
          post?.description ??
          "Analysis, model notes and betting education from the Statlign sports intelligence team.",
        ogType: "article",
      }),
      scripts,
    };
  },
  component: () => (
    <MainLayout>
      <BlogPost />
    </MainLayout>
  ),
});
